import React from "react";
import { Navigate } from "react-router-dom";
import { useRoleAccess } from "@/contexts/RoleAccessContext";
import { SolutionKey } from "@/security/solutionAccess";

type RequireSolutionAccessProps = {
  solution: SolutionKey;
  children: React.ReactElement;
};

export const RequireSolutionAccess: React.FC<RequireSolutionAccessProps> = ({ solution, children }) => {
  const { loading, canAccessSolution } = useRoleAccess();

  if (loading) {
    return <p>Loading permissions...</p>;
  }

  if (!canAccessSolution(solution)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

type RequireAnySolutionAccessProps = {
  solutions: SolutionKey[];
  children: React.ReactElement;
};

export const RequireAnySolutionAccess: React.FC<RequireAnySolutionAccessProps> = ({ solutions, children }) => {
  const { loading, canAccessSolution } = useRoleAccess();

  if (loading) {
    return <p>Loading permissions...</p>;
  }

  const hasAccess = solutions.some((s) => canAccessSolution(s));
  if (!hasAccess) {
    return <Navigate to="/home" replace />;
  }

  return children;
};
